import Vue from 'vue';
import ContentEditor from './content-editor';

export default Vue.component('invite-user', {
  template: require('./template.html'),
  name: 'invite-user',
  components: {
    ContentEditor,
  },
  props: ['modal', 'toggle-modal'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/sub-users/invite/index.js